
export const SET_TAB_DATA = 'SET_TAB_DATA';
export const SET_TAB_LOADER = 'SET_TAB_LOADER';
export const SET_UPDATED_VALUES = 'SET_UPDATED_VALUES';
export const SET_SKILLS = 'SET_SKILLS';
export const SET_SETTINGS = 'SET_SETTINGS';
export const SET_MICROSITES = 'SET_MICROSITES';
export const SET_MICROSITE_ACTIONS = 'SET_MICROSITE_ACTIONS';
export const SET_ACTIVE_PARTNER = 'SET_ACTIVE_PARTNER';